import { useNavigate } from "react-router-dom";
import { Brain, Hand, Sparkles, Users2, Zap } from "lucide-react";

const POINTS = [
  { icon: Users2, text: "Up to 3 friends join one live AI-taught lesson with a shareable Session ID" },
  { icon: Brain, text: "Think First Mode — everyone answers privately before results are ever revealed" },
  { icon: Zap, text: "SmartGuru adapts hints & difficulty to each student while the lesson stays shared" },
  { icon: Hand, text: "Raise Hand, ask questions, react and earn SmartPoints together — never ranked to shame anyone" },
];

export default function LandingStudyTogether() {
  const navigate = useNavigate();
  return (
    <section id="study-together" className="py-10 sm:py-16 bg-white" data-testid="landing-study-together-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 bg-[#9A3DB2]/10 text-[#9A3DB2] border border-[#9A3DB2]/30 rounded-full px-3 py-1 text-xs font-bold" data-testid="study-together-first-badge">
            <Sparkles size={12} className="text-[#9A3DB2]" /> Industry First · 3-Student Real-Time Combine Study
          </span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-3">Combine Study. Think independently. Grow together.</h2>
          <p className="text-muted-foreground mt-3">
            Start a live Combine Study room and invite up to 2 friends with a simple Session ID. SmartGuru teaches
            the whole group as one AI classroom — but tracks every student's understanding individually, so nobody
            gets left behind and nobody gets held back.
          </p>
          <ul className="mt-5 space-y-3">
            {POINTS.map((p) => (
              <li key={p.text} className="flex items-start gap-2.5 text-sm">
                <p.icon size={16} className="text-secondary shrink-0 mt-0.5" /> {p.text}
              </li>
            ))}
          </ul>
          <div className="flex flex-wrap gap-3 mt-6">
            <button onClick={() => navigate("/onboarding")} data-testid="study-together-cta" className="inline-flex items-center gap-2 bg-primary text-primary-foreground font-bold px-6 py-3 rounded-full hover:bg-primary/90 active:scale-95 transition-all">
              <Sparkles size={16} /> Try Combine Study
            </button>
          </div>
        </div>
        <img
          src="https://static.prod-images.emergentagent.com/jobs/efb5525d-e484-4894-a0d3-6f8b4f2b6938/images/20aebebba7307e0af4a211fde0f5e11899287effe35005b7df7eb50092461deb.jpeg"
          alt="Three Indian students in a live Combine Study session with SmartGuru"
          className="rounded-3xl shadow-xl w-full object-cover aspect-[3/4]"
          data-testid="study-together-visual"
        />
      </div>
    </section>
  );
}
